module.exports = __webpack_public_path__ + "img/logo_name.45234b35.png";